/* jslint esversion: 6 */
/**
 * Theme Scripts
 *
 * @package Carbon
 * @subpackage Scripts
 * @since 3.0.0
 */

/** Variables */

/** Imports */
// import ANY_NAME_YOU_WANT from 'folder/module'; // default
// import { FUNCTION as ANY_NAME } from 'folder/module'; // Named

/** Example */
// import moduleName from './theme/module-name';

import carbonFaviconBadge from './theme/carbon-favicon-badge';
import carbonMobileMenu   from './theme/carbon-mobile-menu';
import carbonFancybox     from './theme/carbon-fancybox'; // requires styles

import headerMenu         from './theme/header-menu';

// import carbonMaxWidthIFrame   from './theme/max-width-iframe'; // requires styles
// import carbonMaxWidthTable    from './theme/max-width-table'; // requires styles
// import carbonScrollThrottle   from './theme/scroll-throttle';
// import carbonScrollTransition from './theme/scroll-transition';

// Vanilla JS version of $(document).ready() works in IE9+
document.addEventListener('DOMContentLoaded', function() {
	carbonFaviconBadge();
	carbonMobileMenu();
	carbonFancybox();

	// moduleName();
	headerMenu();

	// carbonMaxWidthIFrame();
	// carbonMaxWidthTable();
	// carbonScrollThrottle();
	// carbonScrollTransition();
});



// WEBPACK FOOTER //
// /app/wp-content/themes/partnershipforthefuture/source/scripts/carbon-scripts-theme.js